// Кнопка смены темы у правого края.
//
// Штатный переключатель Frappe спрятан в меню под именем пользователя и открывает
// диалог с тремя вариантами. Для демонстрации клиенту это два лишних действия:
// показать тёмную тему хочется одним нажатием.
//
// Кнопка переключает светлую и тёмную напрямую, тем же вызовом, что и сам Frappe
// (data-theme-mode на <html> плюс switch_theme на сервере) — иначе выбор не
// пережил бы перезагрузку страницы.
//
// Место — правый край над плашкой «ДЕМО»: она сидит в 16px снизу справа, и две
// круглые кнопки в столбик читаются как один блок, а не спорят за угол.

frappe.provide("nasiya365.theme");

nasiya365.theme.ICONS = {
	// Луна — «включить тёмную», солнце — «вернуть светлую». Значок показывает,
	// что произойдёт по нажатию, а не что включено сейчас.
	toDark: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
	toLight: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>',
};

nasiya365.theme.current = function () {
	return document.documentElement.getAttribute("data-theme-mode") || "light";
};

nasiya365.theme.apply = function (mode) {
	document.documentElement.setAttribute("data-theme-mode", mode);
	// Тот же вызов, что делает штатный переключатель: без него тема слетит при
	// следующей загрузке страницы.
	frappe.xcall("frappe.core.doctype.user.user.switch_theme", {
		theme: mode.charAt(0).toUpperCase() + mode.slice(1),
	});
};

nasiya365.theme.mount = function () {
	if (document.getElementById("nasiya-theme-toggle")) return;

	const btn = document.createElement("button");
	btn.id = "nasiya-theme-toggle";
	btn.type = "button";
	btn.setAttribute("aria-label", __("Сменить тему"));
	btn.title = __("Сменить тему") + " (Shift+Ctrl+G)";

	const paint = () => {
		const dark = nasiya365.theme.current() === "dark";
		btn.innerHTML = dark ? nasiya365.theme.ICONS.toLight : nasiya365.theme.ICONS.toDark;
	};

	btn.addEventListener("click", () => {
		const next = nasiya365.theme.current() === "dark" ? "light" : "dark";
		nasiya365.theme.apply(next);
		paint();
	});

	// Тему может сменить и штатный диалог — тогда значок обязан догнать.
	new MutationObserver(paint).observe(document.documentElement, {
		attributes: true,
		attributeFilter: ["data-theme-mode"],
	});

	paint();
	document.body.appendChild(btn);
};

$(document).on("app_ready", function () {
	nasiya365.theme.mount();
});
